import { Component, computed, inject, signal, Signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MY_ACCOUNT_CONFIG } from '../../../../config/my-account.config';
import { IPackagePrice, PackagePriceService } from '../../../../../public-api';
import { PopUpService } from 'lib-shared';
import { CommonModule } from '@angular/common';
import { MonthSelectionComponent } from "../month-selection/month-selection.component";

@Component({
  selector: 'app-multi-month-plan',
  standalone: true,
  imports: [CommonModule, TranslocoModule, MonthSelectionComponent],
  templateUrl: './multi-month-plan.component.html',
  styleUrl: './multi-month-plan.component.scss'
})
export class MultiMonthPlanComponent {
  private config = inject(MY_ACCOUNT_CONFIG);
  packagePriceService = inject(PackagePriceService);
  popUpService = inject(PopUpService);

  isLoading: boolean = false

  primaryColor: string = this.config.theme.primaryColor;


  packageData: any;
  totalPrice: Signal<number> = signal(0);

  packageID: number = 0;
  virtualNumberCountryID: number = 0;
  didID: number = 0;
  didData: any;
  currentActiveDuration: number = 1;
  packageCountryName: string = '';
  selectedDuration: number = 1;
  renewalPackageID: number = 0;

  ngOnInit(): void {
    this.getPackagePrice();
  }

  async getPackagePrice() {
    try {
      const res =
        await this.packagePriceService.getMyAccountPackagePrice<IPackagePrice>();

      if (res.isSuccessful && res.result) {
        this.packageData = res.result;

       this.currentActiveDuration = res.result.monthsInterval;
        this.selectedDuration = res.result.monthsInterval;

        this.calculateInitialPrice();
      }
    } catch (error) {
      console.error(error);
    }
  }

  calculateInitialPrice() {
    const currentOption = this.packageData.discounts.find(
      (d: any) => d.intervalMonths === this.currentActiveDuration
    );

    if (currentOption) {
      this.totalPrice = computed(() => currentOption.total);
    } else {
      // Si es el plan base de 1 mes
      this.totalPrice = computed(() => this.packageData.price);
    }
  }

  onDurationSelected(event: { months: number; renewalPackageID?: number }) {
    this.selectedDuration = event.months;
    this.renewalPackageID = event.renewalPackageID || 0;
    // Buscar la opción seleccionada para obtener el precio correcto
    const selectedOption = this.packageData.discounts.find(
      (d: any) => d.intervalMonths === event.months
    ) || { price: this.packageData.price };

    const packagePrice = selectedOption.price * event.months;

    this.totalPrice = computed(() => {
      return event.months > 1  ? selectedOption.total : packagePrice
    });
  }

  async onContinue() {
    try {
      const res = await this.packagePriceService.sendRenewalPackageId(this.renewalPackageID);

      if (res.isSuccessful) {
        this.popUpService.openPopUp('renewal-success')
        this.getPackagePrice();
      } else {
        this.popUpService.openPopUp('renewal-error')
      }
    } catch (error) {
      console.error('Error in onContinue:', error);
    }
  }
}
